import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
} from '@mui/material';
import { CloseOutlined } from '@mui/icons-material';
import { Library } from '@userpath/constants';
import { Lang } from '@userpath/localization';
import { ArticleCard } from '@userpath/components';
import { ConfigOverrider } from '@userpath/utils';
import { ArticleDTO } from '@userpath/types';
import { Styled } from './styles';
import { Device } from './Device';

interface IPreviewArticlesProps {
  article: ArticleDTO;
  open?: boolean;
  onClose: () => void;
}

const PreviewArticles: React.FC<IPreviewArticlesProps> = ({
  article,
  open = false,
  onClose,
}) => {
  const { t: ot, i18n } = useTranslation(Library.userpath);
  const [isMobile, setIsMobile] = useState(false);
  const [isArabic, setIsArabic] = useState(i18n.language == Lang.AR);
  const updateLanguage = useCallback(() => {
    setIsArabic((old) => !old);
  }, []);
  const updateView = useCallback(() => {
    setIsMobile((old) => !old);
  }, []);

  return (
    <Styled.Dialog
      open={open}
      maxWidth="xl"
      onClose={onClose}
      aria-labelledby="preview-articles-title"
    >
      <DialogTitle id="preview-articles-title">
        {ot('admin.article.previewArticle')}
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseOutlined />
      </IconButton>
      <DialogContent dividers>
        <ConfigOverrider
          lang={isArabic ? Lang.AR : Lang.EN}
          forceBreakpoint={isMobile ? 'xs' : 'md'}
        >
          <Device device={isMobile ? 'mobile' : 'desktop'}>
            <Styled.Container
              bgcolor={(theme) => theme.palette.background.paper}
              isArabic={isArabic}
            >
              <Grid container>
                <Grid item xs={12} md={3} />
                <Grid item xs={12} md={6}>
                  <ArticleCard disableInteractions article={article} />
                </Grid>
                <Grid item xs={12} md={3} />
              </Grid>
            </Styled.Container>
          </Device>
        </ConfigOverrider>
      </DialogContent>
      <DialogActions>
        <Button onClick={updateLanguage}>
          {ot(isArabic ? 'admin.article.english' : 'admin.article.arabic')}
        </Button>
        <Button onClick={updateView}>
          {ot(isMobile ? 'admin.article.desktop' : 'admin.article.mobile')}
        </Button>
      </DialogActions>
    </Styled.Dialog>
  );
};

export default PreviewArticles;
